import { render, staticRenderFns } from "./miscellaneous-invoice.vue?vue&type=template&id=5b21d2a6&"
import script from "./miscellaneous-invoice.vue?vue&type=script&lang=js&"
export * from "./miscellaneous-invoice.vue?vue&type=script&lang=js&"
import style0 from "./miscellaneous-invoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports